export class BranchTranslationModel {
    constructor(data = { id: '', language_id: '', label: '' }) {
        this.id = data.id;
        this.language_id = data.language_id;
        this.label = data.label;
    }
}
